(function () {
    if (window.__pharmaSolutionsInit) 
        return;
    window.__pharmaSolutionsInit = true;
    function cartAddUrl() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
    }

    function showToast(root, message, type) {
        var toast = document.createElement('div');
        toast.className = 'pharma-toast' + (type === 'error' ? ' error' : '');
        toast.textContent = message;
        (root || document.body).appendChild(toast);
        setTimeout(function () {
            toast.style.animation = 'pharma-slide-out 0.3s ease';
            setTimeout(function () { toast.remove(); }, 300);
        }, 3000);
    }

    function handleAddToCart(btn) {
        var root = btn.closest('.pharma-solutions-section');
        var row = btn.closest('.product-row');
        var variantId = btn.dataset.variantId;

        if (!variantId) {
            showToast(root, 'This product is not set up yet', 'error');
            return;
        }

        var qtyInput = row.querySelector('.qty-input');
        var quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        var originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('loading');
        btn.innerHTML = '<span class="spinner"></span>';

        fetch(cartAddUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
            .then(function (res) {
                return res.json().then(function (data) { return { ok: res.ok, data: data }; });
            })
            .then(function (result) {
                if (!result.ok) {
                    throw new Error(result.data.description || 'Unable to add this item to your cart');
                }
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            })
            .catch(function (err) {
                showToast(root, err.message, 'error');
            })
            .finally(function () {
                btn.disabled = false;
                btn.classList.remove('loading');
                btn.innerHTML = originalContent;
            });
    }

    function updateCategoriesNav(wrapper) {
        var row = wrapper.querySelector('.categories-row');
        var prev = wrapper.querySelector('.categories-nav-prev');
        var next = wrapper.querySelector('.categories-nav-next');
        if (!row) return;
        var maxScroll = row.scrollWidth - row.clientWidth - 1;
        if (prev) prev.disabled = row.scrollLeft <= 0;
        if (next) next.disabled = row.scrollLeft >= maxScroll;
    }

    function initCategoriesNav() {
        document.querySelectorAll('.categories-row-wrapper.has-nav').forEach(function (wrapper) {
            updateCategoriesNav(wrapper);
            var row = wrapper.querySelector('.categories-row');
            if (row) {
                row.addEventListener('scroll', function () { updateCategoriesNav(wrapper); });
            }
        });
    }

    document.addEventListener('DOMContentLoaded', initCategoriesNav);
    window.addEventListener('resize', function () {
        document.querySelectorAll('.categories-row-wrapper.has-nav').forEach(updateCategoriesNav);
    });

    document.addEventListener('click', function (e) {
        var minus = e.target.closest('.qty-minus');
        var plus = e.target.closest('.qty-plus');
        var addBtn = e.target.closest('.add-to-cart');
        var categoriesNavBtn = e.target.closest('.categories-nav');

        if (categoriesNavBtn && !categoriesNavBtn.disabled) {
            var wrapper = categoriesNavBtn.closest('.categories-row-wrapper');
            var row = wrapper && wrapper.querySelector('.categories-row');
            if (row) {
                var direction = categoriesNavBtn.classList.contains('categories-nav-next') ? 1 : -1;
                row.scrollBy({ left: direction * row.clientWidth * 0.8, behavior: 'smooth' });
            }
        } else if (minus) {
            var input = minus.parentElement.querySelector('.qty-input');
            var min = parseInt(input.min, 10) || 1;
            input.value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
        } else if (plus) {
            var input2 = plus.parentElement.querySelector('.qty-input');
            input2.value = (parseInt(input2.value, 10) || 0) + 1;
        } else if (addBtn && !addBtn.disabled) {
            handleAddToCart(addBtn);
        }
    });

    document.addEventListener('change', function (e) {
        if (e.target.classList.contains('qty-input')) {
            var min = parseInt(e.target.min, 10) || 1;
            e.target.value = Math.max(min, parseInt(e.target.value, 10) || min);
        }
    });

})();
